<template>

	<div class="user_wbox" :class="{ 'mobile-detail': isMobile }" style="padding-top: 20px;margin-top: 0;">
		<el-container>
			<div class="inter">

				<div class="back-btn-top" @click="goBack">
					<i class="el-icon-arrow-left"></i> 返回
				</div>

				<div class="sjz_goods_detail_container" v-if="info.archives">
				<div v-if="archiveStatus === 'deleted' || archiveStatus === 'suspended'" class="archive-status-warning">
					<i class="el-icon-warning"></i>
					<span>当前账号已{{ archiveStatus === 'deleted' ? '被删除' : '下架' }}，仅管理员可见</span>
				</div>
					<div class="sjz_goods_info">
						<div class="sjz_goods_title">
							<!-- <span class="back-btn" @click="goBack">
								<i class="el-icon-arrow-left"></i> 返回
							</span> -->
							{{ info.archives.title }}</div>
						<div class="sjz_account_info">
							<div class="info_row">
								<div class="info_item">
									<div class="info_label">{{ info.archives.login_type_text }}</div>
									<div class="info_value">登录方式</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.qufu_text }}</div>
									<div class="info_value">游戏区服</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.duanwei_text }}</div>
									<div class="info_value">段位</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.liutao || '-' }}</div>
									<div class="info_value">六套数量</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.chunbi }}</div>
									<div class="info_value">纯币资产(m)</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.level }}</div>
									<div class="info_value">账号等级</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.xunlian }}级</div>
									<div class="info_value">训练中心</div>
								</div>
								<div class="info_item" style="padding: 12px 0px;">
									<div class="info_label">{{ info.archives.box_text }}</div>
									<div class="info_value">安全箱</div>
								</div>
								<div class="info_item">
									<div class="info_label"> {{ info.archives.bachang }}级</div>
									<div class="info_value">靶场登记</div>
								</div>
							</div>
							<div class="info_row">
								<div class="info_item">
									<div class="info_label">{{ info.archives.zuqi }}</div>
									<div class="info_value">租期</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.awm }}</div>
									<div class="info_value">awm子弹</div>
								</div>
								
								<div class="info_item">
									<div class="info_label">{{ info.archives.is_feng_text }}</div>
									<div class="info_value">封禁记录</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.is_ben_text }}</div>
									<div class="info_value">人脸是否本人</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.changzhu_text }}</div>
									<div class="info_value">常用登录地</div>
								</div>
								<div class="info_item">
									<div class="info_label"> {{ info.archives.leixing_text }}</div>
									<div class="info_value">账号类型</div>
								</div>
								<div class="info_item special">
									<div class="special_content" @click="showSkinDialog" style="cursor: pointer;">
										<div class="special_item"><span class="special_label" style="text-decoration: underline;">持有刀皮</span>

											<span class="special_value tooltip-text" data-tooltip="" style="text-decoration: underline;">{{
												info.archives.daopi_text }}</span>
										</div>
										<div class="special_item"><span class="special_label" style="text-decoration: underline;">干员外观</span><span
												class="special_value tooltip-text" data-tooltip="" style="text-decoration: underline;">{{
													info.archives.ganyuan_text }}</span>
										</div>
									</div>
								</div>
							</div>
							<div class="info_item" v-if="info.archives.beizhu" style="width: 100%; clear: both; margin-top: 10px; padding: 10px; background: #fdf6ec; border-radius: 4px;">
								<div class="info_label" style="color: #e6a23c;">{{ info.archives.beizhu }}</div>
								<div class="info_value">备注</div>
							</div>
						</div>
						<div class="ant-row" style="margin-bottom: 22px;">
							<div class="" style="text-align: right;"><span class="msg-series-large">比例 <span
										class="msg-series-text">{{ info.archives.bili }}</span></span><span
									class="msg-series-large">价格<span class="msg-series-price">{{ info.archives.price
									}}<span class="msg-series-unit">元</span></span></span><span
									class="msg-series-large last-item">押金<span class="msg-series-value">{{ info.archives.yajin }}<span
											class="msg-series-unit">元</span></span></span></div>
						</div>
						<div class="ant-row ant-row2" style="padding: 16px 20px;">
							<div class="ant-col-6">
								<div style="display: flex;">
									<div class="goods-code-box">
										<p>商品编号</p>
										<p style="color: rgb(51, 51, 51); cursor: pointer; font-size: 18px; font-weight: bold;">{{ info.archives.account_no || info.archives.id }}<i
												class="icon-copy-div"></i></p>
										<p style="font-size: 12px; color: #999; margin-top: 4px;">更新时间：{{ formatDateTime(info.archives.updatetime) }}</p>
									</div>
								</div>
							</div>
							<div class="ant-col-8 ant-col-offset-10" :style="isMobile ? '' : 'display: none;'" style="text-align: right;">
								<div class="" style="display: flex; align-items: center; justify-content: end;">
									<button type="button" @click="showKefuDialog" class="ant-btn goodstail-btn order-btn" style="width: 150px;">
										<p style="font-size: 14px;">联系客服下单</p>
									</button>
								</div>
							</div>
						</div>
					</div>





					<div class="sjz_goods_detail">

						<div class="table_list">
							<div class="detail-content">
								<div class="lease_kown_bottom">
									<div class="know_title">账号租赁规则须知</div>
									<div class="know_intro">欢迎租用本平台账号，为保障租赁双方权益、避免纠纷，请所有租客仔细阅读并严格遵守以下规则，租赁即代表已同意全部条款。</div>
									<div class="know_section">
										<div class="section_title">一、上号与租期要求</div>
										<div class=""><span class="mark_styles_number">1</span><span>加入群组后请主动联系号主，确认具体上号时间。本平台仅提供当日租赁服务，需在租赁当天完成账号登录。</span></div>
										<div class=""><span class="mark_styles_number">2</span><span>请在标注租期内正常使用账号；额度超500m的超大额账号，需先与号主商量好租期再上号。</span></div>
										<div class=""><span class="mark_styles_number">3</span><span>上号后请立即验号，若发现账号不符请在20分钟内提出，超时未反馈视为验号通过，验号通过后无特殊问题不退不换。</span></div>
									</div>
									<div class="know_section">
										<div class="section_title">二、物资使用规范</div>
										<div class=""><span class="mark_styles_number">1</span><span>租赁期间仅允许使用账号内纯币（哈夫币），平台仅对纯币进行统计。如需使用纯币以外的任何物资，必须提前联系号主确认使用细节及费用，未沟通擅自使用的，一切后果自行承担。</span></div>
										<div class=""><span class="mark_styles_number">2</span><span>严禁擅自使用仓库拓展箱、各类道具、礼包、点券、三角券等物品；如需使用制式券、活动道具等，需提前与号主商议，未经许可不得使用。</span></div>
									</div>
									<div class="know_section">
										<div class="section_title">三、账号安全核查与封禁处罚</div>
										<div class=""><span class="mark_styles_number">1</span><span>近期腾讯官方风控较严，存在无故误封、异常封号情况，租客进群后务必先核查账号安全中心封禁记录与实名认证信息，确认无误后再进行养号及后续操作，未提前核查导致的后果自行承担。</span></div>
										<div class=""><span class="mark_styles_number">2</span><span>未使用账号时发现封禁记录，可联系客服换号；账号已使用则不予退换，后续风险自行承担。</span></div>
										<div class=""><span class="mark_styles_number">3</span><span>租期内账号出现封禁，仅在租客/打手无法自证非自身违规操作时，按以下标准赔付号主：</span></div>
										<div class="indent"><span>◦ 封禁11-30天：扣除50%押金+全部号款</span></div>
										<div class="indent"><span>◦ 封禁30天以上：扣除全部押金+全部号款</span></div>
										<div class="indent"><span>◦ 若能证实为腾讯官方误封，或号主主动免责，可免除赔付。</span></div>
									</div>
									<div class="know_section">
										<div class="section_title">四、沟通与行为准则</div>
										<div class=""><span class="mark_styles_number">1</span><span>严禁向他人透露租赁价格等相关信息，禁止辱骂客服及号主，合理需求会及时处理。</span></div>
										<div class=""><span class="mark_styles_number">2</span><span>客服日常咨询较多，群消息可能无法及时查看，遇问题请直接私信沟通。</span></div>
										<div class=""><span class="mark_styles_number">3</span><span>严禁售卖账号内特殊物品（含活动道具，如勇者之证、彦祖之镜等），违者照价赔偿。</span></div>
									</div>
								</div>
							</div>
						</div>



					</div>
				</div>

			</div>

		</el-container>
		
		<el-dialog
			title="联系客服下单"
			:visible.sync="kefuDialogVisible"
			width="400px"
			:close-on-click-modal="true"
			:close-on-press-escape="true"
			:show-close="true"
			destroy-on-close>
			<div style="text-align: center; padding: 20px;">
				<div style="font-size: 24px; font-weight: bold; margin-bottom: 20px; color: #E6A23C;">
					{{ info.archives && info.archives.account_no ? info.archives.account_no : '暂无编号' }}
				</div>
				<div v-if="kefuInfo && kefuInfo.qrcode" style="margin-bottom: 20px;">
					<img :src="fixImageUrl(kefuInfo.qrcode)" style="width: 200px; height: 200px; object-fit: contain;" />
				</div>
				<div style="font-size: 16px; margin-bottom: 10px;">
					客服姓名：{{ kefuInfo ? kefuInfo.name : '-' }}
				</div>
				<div style="font-size: 16px; margin-bottom: 10px;">
					微信号：{{ kefuInfo ? kefuInfo.wechat : '-' }}
				</div>
				<div style="font-size: 14px; color: #909399; margin-top: 20px;">
					请扫码添加客服微信或搜索微信号添加
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="goToOrderAfterKefu">确认已联系客服</el-button>
			</span>
		</el-dialog>

		<el-dialog
			title="外观信息"
			:visible.sync="skinDialogVisible"
			width="500px"
			:close-on-click-modal="true"
			:close-on-press-escape="true"
			:show-close="true"
			destroy-on-close>
			<div style="padding: 10px 20px;">
				<div style="margin-bottom: 20px;">
					<div style="font-size: 16px; font-weight: bold; margin-bottom: 10px; color: #303133;">持有刀皮</div>
					<div style="font-size: 14px; color: #606266; padding: 8px 12px; background: #f5f7fa; border-radius: 4px;">
						{{ info.archives && info.archives.daopi_text ? info.archives.daopi_text : '-' }}
					</div>
				</div>
				<div style="margin-bottom: 20px;">
					<div style="font-size: 16px; font-weight: bold; margin-bottom: 10px; color: #303133;">干员外观</div>
					<div style="font-size: 14px; color: #606266; padding: 8px 12px; background: #f5f7fa; border-radius: 4px;">
						{{ info.archives && info.archives.ganyuan_text ? info.archives.ganyuan_text : '-' }}
					</div>
				</div>
				<div>
					<div style="font-size: 16px; font-weight: bold; margin-bottom: 10px; color: #303133;">武器皮肤</div>
					<div style="font-size: 14px; color: #606266; padding: 8px 12px; background: #f5f7fa; border-radius: 4px;">
						{{ info.archives && info.archives.wuqi_text ? info.archives.wuqi_text : '-' }}
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="skinDialogVisible = false">关闭</el-button>
			</span>
		</el-dialog>
	</div>

</template>
<script>
import {
	Notification,
	Message
} from 'element-ui'
export default {
	data() {
		return {
			goods: {},
			goods_id: 0,
			loading: true,
			info: {},
			daqu: {},
			baopei: {},
			jiaoyi: {},
			kefu: [],
			qun: [],
			type: 0,
			shouxufei: 0,
			activeName: "0",
			kefu_url: "",
			kefuInfo: null,
			kefuDialogVisible: false,
			skinDialogVisible: false,
			archiveStatus: ''


		}
	},
	computed: {
		userinfo() {
			return this.$store.getters.userinfo
		},
		gamelist() {
			return this.$store.getters.gamelist
		},
		config() {
			return this.$store.getters.config
		},
		isMobile() {
			return this.$store.getters.isMobile
		},
		login() {
			return this.$store.getters.login
		},
	},
	created: function (data) {

		this.goods_id = this.$route.query.id

		if (this.goods_id == undefined) {
			this.goods_id = this.$route.params.id
		}

		this.getDetail(this.goods_id);
		this.getCollect()

		// https://tb.53kf.com/code/client/10000079/1?u_cust_id=999&u_cust_name=测试&u_custom_info=123456 

	},
	watch: {
		$route() {

		}
	},
	methods: {
		goBack() {
			if (!this.$router.go(-1)) {
				this.$router.push('/');
			}
		},
		openKefu() {

			// api_kefu.push('cmd', 'comeinfo');


			// api_kefu.push('title', '账号编号' + this.goods.id);
			// api_kefu.push('logo', this.goods.image);
			// api_kefu.push('content', '账号编号' + this.goods.id);


			// api_kefu.push('curl', 'https://www.yihaods.com/goodsdetail?id=' + this.goods.id);

			// api_kefu.query();

			// api_kefu.push('cmd', 'kfclient');
			// api_kefu.push('type', 'new');
			// api_kefu.query();
			this.$parent.openKefu()




		},
		addOrder() {


			if(!this.login){
				this.$parent.$refs['login'].active = 0
				this.$parent.$refs['login'].visible = true
				return;
			}

			if (this.info.kefu && (this.info.kefu.kefu_code || this.info.kefu.name || this.info.kefu.wechat)) {
				this.kefuInfo = this.info.kefu;
				this.kefuDialogVisible = true;
			} else if (this.info.archives && (this.info.archives.kefu_name || this.info.archives.kefu_wechat || this.info.archives.kefu_qrcode)) {
				this.kefuInfo = {
					name: this.info.archives.kefu_name || '',
					wechat: this.info.archives.kefu_wechat || '',
					qrcode: this.info.archives.kefu_qrcode || ''
				};
				this.kefuDialogVisible = true;
			} else {
				this.$router.push('/addorder?id=' + this.info.archives.id)
			}
		},
		showKefuDialog() {
			if (this.info.kefu && (this.info.kefu.kefu_code || this.info.kefu.name || this.info.kefu.wechat)) {
				this.kefuInfo = this.info.kefu;
				this.kefuDialogVisible = true;
			} else if (this.info.archives && (this.info.archives.kefu_name || this.info.archives.kefu_wechat || this.info.archives.kefu_qrcode)) {
				this.kefuInfo = {
					name: this.info.archives.kefu_name || '',
					wechat: this.info.archives.kefu_wechat || '',
					qrcode: this.info.archives.kefu_qrcode || ''
				};
				this.kefuDialogVisible = true;
			} else {
				this.$message.warning('该账号未绑定客服');
			}
		},
		showSkinDialog() {
			this.skinDialogVisible = true;
		},
		goToOrderAfterKefu() {
			this.kefuDialogVisible = false;
		},
		getDetail(id) {
			var that = this;
			this.rq.requests.post("api/game/hall/ArchivesDetail", {
				id: id,
			}).then(res => {
				// ?u_cust_id=999&u_cust_name=测试&u_custom_info=123456 

				if (res.data.archives.images != '' && res.data.archives.images != null) {
					res.data.archives.images = res.data.archives.images.split(',');
				}

				const fallbackMap = {
					daopi: { 
						1: '信条', 2: '赤霄', 3: '怜悯', 4: '影锋', 5: '黑海', 6: '北极星', 7: '电锯惊魂', 8: '龙牙', 9: '暗星'
					},
					ganyuan: { 
						1: '红狼 - 蚀金玫瑰', 2: '红狼 - 黑鹰坠落', 3: '威龙 - 蛟龙行动', 4: '威龙 - 铁面判官', 5: '威龙 - 吴彦祖', 
						6: '蜂医 - 送葬人', 7: '蜂医 - 黑鹰坠落', 8: '蜂医 - 危险物质', 9: '无名 - 夜鹰', 10: '乌鲁售・黑鹰坠落',
						11: '牧羊人 - 黑鹰坠落', 12: '牧羊人 - 街头之王', 13: '露娜 - 黑 - 天际线', 14: '蛊 - 能天使 - 午夜邮差',
						15: '骇爪 - 维什戴尔', 16: '骇爪 - 水墨云图', 17: '露娜 - 金牌射手', 18: '深蓝 - 不破之誓', 
						19: '红狼 - 电锯惊魂', 20: '威龙 - 凌霄戍卫'
					},
					wuqi: {
						1: 'M7 棱镜攻势', 2: 'M4 棱镜攻势', 3: 'K416 - 命运', 4: 'SCAR - 电玩', 5: '腾龙 - 气象感应', 
						6: 'QBZ95 - 王牌之剑', 7: 'Vctor - 中锋枪 - 美杜莎', 8: 'AS Val 突击步枪 - 悬赏令', 9: 'AUG - 气象感应'
					},
					changzhu: {
						1: '北京', 2: '天津', 3: '河北', 4: '山西', 5: '内蒙古', 6: '辽宁', 7: '吉林', 8: '黑龙江',
						9: '上海', 10: '江苏', 11: '浙江', 12: '安徽', 13: '福建', 14: '江西', 15: '山东', 16: '河南',
						17: '湖北', 18: '湖南', 19: '广东', 20: '广西', 21: '海南', 22: '重庆', 23: '四川', 24: '贵州',
						25: '云南', 26: '西藏', 27: '陕西', 28: '甘肃', 29: '青海', 30: '宁夏', 31: '新疆', 32: '台湾',
						33: '香港', 34: '澳门'
					}
				};

				['daopi', 'ganyuan', 'wuqi'].forEach(field => {
					if (res.data.archives[field] && fallbackMap[field]) {
						const values = res.data.archives[field].split(',');
						const texts = values.map(v => fallbackMap[field][v] || v);
						res.data.archives[field + '_text'] = texts.join(', ');
					}
				});

				if (res.data.archives.changzhu && fallbackMap.changzhu) {
					res.data.archives.changzhu_text = fallbackMap.changzhu[res.data.archives.changzhu] || res.data.archives.changzhu;
				}

				that.info = res.data;
				that.archiveStatus = res.data.archive_status || '';
				that.loading = false;
				that.kefu_url = 'https://tb.53kf.com/code/client/dbcf39efd2c649334d9816205b768c0e3/1?u_cust_id=' + user_id + '&u_cust_name=' + nickname + '&u_custom_info=' + this.goods.title

			}).catch(error => {

			})
		},

		shoucang() {
			var that = this;


			var logined = Boolean(localStorage.getItem('usertoken'))

			if (!logined) {
				this.$router.push('/login')
				return;
			}

			this.rq.requests.post("api/game/user/pullCollect", {

				id: that.goods_id,
				type: that.type

			}).then(res => {

				if (that.type == 0) {
					that.type = 1;

					Message.success({
						message: "收藏成功",
						duration: 3000
					})
				} else {
					that.type = 0;
					Message.success({
						message: "已取消",
						duration: 3000
					})
				}

			}).catch(error => {

			})

		},


		  formatDateTime(timeStr) {
    if (!timeStr) return '-';
    const timestamp = parseInt(timeStr) * 1000 ;
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${year}年${month}月${day}日 ${hours}:${minutes}`;
  },
		getCollect() {
			var that = this;
			this.rq.requests.post("api/game/user/getCollect", {
				id: this.goods_id

			}).then(res => {

				if (res.data.status == 1) {
					that.type = 1;
				}


			}).catch(error => {

			})
		},



	}
}
</script>
<style>
.back-btn-top {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	color: #1f9535;
	cursor: pointer;
	font-size: 14px;
	margin-bottom: 15px;
}
.back-btn-top:hover {
	color: #16752a;
}
.sjz_goods_title .back-btn {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	color: #1f9535;
	cursor: pointer;
	font-size: 14px;
	margin-right: 10px;
}
.sjz_goods_title .back-btn:hover {
	color: #16752a;
}
.zuhao .el-radio__input {
	display: flex !important;
	align-items: center;
}

.zuhao .el-radio__input.is-checked .el-radio__inner {
	border-color: #508aff;
	background: #508aff;
}

.zuhao .el-radio__input.is-checked+.el-radio__label {
	color: #508aff;
}

.mobile-detail .sjz_account_info .info_row {
	display: flex;
	flex-wrap: wrap;
}

.mobile-detail .sjz_account_info .info_item {
	width: 28%;
	padding: 8px 5px;
	box-sizing: border-box;
}

.mobile-detail .sjz_account_info .info_item .info_label {
	font-size: 12px;
	margin-bottom: 2px;
	
}

.mobile-detail .sjz_account_info .info_item .info_value {
	font-size: 10px;
}

.mobile-detail .sjz_account_info .info_item.special {
	width: 100%;
}

.mobile-detail .sjz_goods_title {
	font-size: 16px;
	padding: 10px;
	color: #acb6c2;
}

.mobile-detail .ant-btn.goodstail-btn.order-btn {
	width: 160px !important;
	padding: 10px 15px !important;
	background: #1f9535 !important;
	border-color: #1f9535 !important;
}

.mobile-detail .ant-btn.goodstail-btn.order-btn p {
	color: #fff !important;
}

.mobile-detail .ant-row {
	padding: 10px;
	margin-bottom: 10px !important;
}

.mobile-detail .goods-code-box {
	padding: 10px;
}

.mobile-detail .order-btn {
	width: 120px !important;
	padding: 8px 10px !important;
}

.mobile-detail .order-btn p {
	font-size: 12px !important;
}

@media (max-width: 768px) {
	.footer {
		display: none;
	}
}

.lease_kown_bottom .know_title {
	font-size: 18px;
	font-weight: bold;
	text-align: center;
	margin-bottom: 15px;
	color: #333;
}

.lease_kown_bottom .know_intro {
	font-size: 14px;
	color: #666;
	margin-bottom: 20px;
	line-height: 1.6;
	padding: 10px;
	background: #f5f5f5;
	border-radius: 4px;
}

.lease_kown_bottom .know_section {
	margin-bottom: 20px;
}

.lease_kown_bottom .section_title {
	font-size: 15px;
	font-weight: bold;
	color: #1f9535;
	margin-bottom: 10px;
	padding-left: 10px;
	border-left: 3px solid #1f9535;
}

.lease_kown_bottom .indent {
	padding-left: 30px;
	margin: 5px 0;
	color: #666;
}

.archive-status-warning {
	background: #fff7e6;
	border: 1px solid #feb952;
	border-radius: 4px;
	padding: 12px 16px;
	margin-bottom: 15px;
	display: flex;
	align-items: center;
	gap: 8px;
	color: #d48806;
	font-size: 14px;
	font-weight: 500;
}

.archive-status-warning i {
	font-size: 18px;
}
</style>